export const Spinner = {
	small: 'var(--epods--spinner-small-size)',
	medium: 'var(--epods--spinner-medium-size)',
	large: 'var(--epods--spinner-large-size)',
};
